// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__F2r8w","itemTitle":"ClientEmergencyInfo_itemTitle__1_Z8V","itemText":"ClientEmergencyInfo_itemText__27MGS"};